import {
  SET_DICTIONARY,
  SET_CURRENT_LANGUAGE,
  SET_LIST_LANGUAGE,
  SET_FONT_SIZE,
  ADJUST_FONT_SIZE,
} from './constants';

export const setDictionary = (state) => {
  return {
    type: SET_DICTIONARY,
    payload: state,
  };
};

export const setListLanguage = (state) => {
  return {
    type: SET_LIST_LANGUAGE,
    payload: state,
  };
};

export const setCurrentLanguage = (state) => {
  return {
    type: SET_CURRENT_LANGUAGE,
    payload: state,
  };
};

export const setFontSize = (state) => {
  return {
    type: SET_FONT_SIZE,
    payload: state,
  };
};

export const adjustFontSize = (state) => {
  return {
    type: ADJUST_FONT_SIZE,
    payload: state,
  };
};
